import React from 'react';
import { CartItemProps } from '../stores/cart-context';

const useBuildMembership = () => {

  const buildMembership = React.useCallback((products: CartItemProps[]) => {
    let memOrderString = '';
    if (products.length === 1) {
      if (products[0].amount === 1) {
        return products[0].membership;
      }
    }
    products.map(item => {
      return memOrderString += memOrderString ? ` and ${item.amount} x ${item.membership}` : `${item.amount} x ${item.membership}`;
    });
    return memOrderString
  }, []);

  return {
    buildMembership
  }
};

export default useBuildMembership;